export default __webpack_public_path__ + "static/media/shark2.c6a560d3.jpg";